export default "__VITE_ASSET__DyXOwCnQ__"